export default "__VITE_ASSET__BjB9h22M__"